/* Minuzza CRO: entrada suave das faixas ao rolar. Sem JS ou com movimento reduzido, tudo aparece de imediato. */
(function () {
  if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    document.querySelectorAll('.cro-reveal').forEach(function (el) { el.classList.add('in'); });
    return;
  }
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); }
    });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
  function watch() { document.querySelectorAll('.cro-reveal:not(.in)').forEach(function (el) { io.observe(el); }); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watch); else watch();
  document.addEventListener('shopify:section:load', watch);
})();

/* Campo de busca do cabeçalho (M-14): o clique abre a busca rápida do tema, a mesma da lupa. */
(function () {
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-cro-search-open]');
    if (!trigger) return;
    /* o cabeçalho tem duas buscas no HTML (uma no modo compacto, escondida): clica na que está visível */
    var summary = Array.prototype.find.call(document.querySelectorAll('.site-header .search-popdown summary'), function (s) {
      var r = s.getBoundingClientRect(); return r.width > 0 && r.height > 0;
    });
    if (summary) { e.preventDefault(); summary.click(); }
  });
})();

/* Prazo de entrega por CEP (snippets/cro-frete.liquid: bloco da página de produto e resumo da sacola).
   O ViaCEP devolve cidade e UF; o prazo vem da tabela por UF de Configurações do tema > Prazo de entrega por CEP. */
(function () {
  function initFrete() {
    Array.prototype.slice.call(document.querySelectorAll('[data-cro-frete]')).forEach(function (root) {
      if (root.getAttribute('data-cro-init')) return;
      root.setAttribute('data-cro-init', '1');
      var cep = root.querySelector('[data-cro-frete-cep]');
      var btn = root.querySelector('[data-cro-frete-botao]');
      var out = root.querySelector('[data-cro-frete-saida]');
      var dica = root.querySelector('[data-cro-frete-dica]');
      if (!cep || !btn || !out) return;

      /* tabela do editor: uma linha por faixa, "SP, RJ: 2 a 4 dias úteis" */
      var prazos = {};
      (root.getAttribute('data-tabela') || '').split(/\r?\n/).forEach(function (linha) {
        var i = linha.indexOf(':');
        var prazo = i > 0 ? linha.slice(i + 1).trim() : '';
        if (!prazo) return;
        linha.slice(0, i).split(/[\s,;]+/).forEach(function (uf) { if (/^[A-Za-z]{2}$/.test(uf)) prazos[uf.toUpperCase()] = prazo; });
      });
      var padrao = (root.getAttribute('data-padrao') || '').trim();
      var frete = (root.getAttribute('data-frete') || '').trim();
      var aviso = (root.getAttribute('data-aviso') || '').trim();
      var pedido = 0;

      function linha(rotulo, valor, destaque) {
        var p = document.createElement('p');
        p.className = 'cro-frete__linha' + (destaque ? ' cro-frete__linha--ok' : '');
        var r = document.createElement('span');
        r.textContent = rotulo;
        var v = document.createElement('strong');
        v.textContent = valor;
        p.appendChild(r);
        p.appendChild(v);
        return p;
      }
      function limpar() { while (out.firstChild) out.removeChild(out.firstChild); out.classList.remove('is-erro'); if (dica) dica.hidden = true; }
      function msg(texto, erro) {
        limpar();
        out.classList.toggle('is-erro', Boolean(erro));
        var p = document.createElement('p');
        p.className = 'cro-frete__msg';
        p.textContent = texto;
        out.appendChild(p);
      }
      function resultado(cidade, uf) {
        limpar();
        var card = document.createElement('div');
        card.className = 'cro-frete__card';
        card.appendChild(linha('Destino', cidade + ' · ' + uf));
        card.appendChild(linha('Prazo', prazos[uf] || padrao || 'Calculado no checkout'));
        if (frete) card.appendChild(linha('Frete', frete, true));
        out.appendChild(card);
        if (aviso) {
          var a = document.createElement('p');
          a.className = 'cro-frete__aviso';
          a.textContent = aviso;
          out.appendChild(a);
        }
      }
      function consultar() {
        var digitos = cep.value.replace(/\D/g, '');
        if (digitos.length !== 8) { msg('Digite um CEP com 8 números.', true); return; }
        var este = ++pedido;
        msg('Consultando o CEP…');
        btn.disabled = true;
        var ctl = window.AbortController ? new AbortController() : null;
        var corte = window.setTimeout(function () { if (ctl) ctl.abort(); }, 8000);
        fetch('https://viacep.com.br/ws/' + digitos + '/json/', ctl ? { signal: ctl.signal } : undefined)
          .then(function (r) { if (!r.ok) throw new Error('http'); return r.json(); })
          .then(function (d) {
            if (este !== pedido) return;
            if (!d || d.erro || !d.uf) { msg('CEP não encontrado. Confira os números.', true); return; }
            resultado(d.localidade || '', String(d.uf).toUpperCase());
          })
          .catch(function () { if (este === pedido) msg('Não foi possível consultar o CEP agora. O prazo aparece no checkout.', true); })
          .then(function () { window.clearTimeout(corte); btn.disabled = false; });
      }

      cep.addEventListener('input', function () {
        var d = cep.value.replace(/\D/g, '').slice(0, 8);
        cep.value = d.length > 5 ? d.slice(0, 5) + '-' + d.slice(5) : d;
      });
      cep.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); consultar(); } });
      btn.addEventListener('click', consultar);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initFrete); else initFrete();
  document.addEventListener('shopify:section:load', initFrete);
})();
